// src/components/HistoriaClinica/Altahistoriaclinica/CuestionarioPorEspecialidadHistoria.js
import React from "react";
import Accordion from "../Accordion";
import { CATALOGO, ESPECIALIDADES, PREGUNTAS_NOM24_GENERALES, PREGUNTAS_NOM24_GERONTOLOGIA, PREGUNTAS_NOM24_SALUD_MATERNA, PREGUNTAS_NOM24_PEDIATRIA  } from "../../../../services/cuestionariocatalog";
import { variableAplica  } from "../../../../utils/validaciones/elegibilidad";


export default function CuestionarioPorEspecialidadHistoria({
  especialidadMedico,
  historia,
  setHistoria,
  openRubros,
  toggleRubro,
  selectedKeys, // Set<string> | null
  nom024 = false,
  edadPaciente,
  edadMesesPaciente,
  sexo,
  fechaNacimiento,
}) {
  // Normaliza array de preguntas → name/type (switch para boolean)
  const mapQuestions = (arr = []) =>
    (arr || []).map((q) => ({
      ...q,
      name: q.name || q.key,
      type: q.type || (q.tipo === "boolean" ? "switch" : q.tipo),
      labels: q.labels || null,
    }));

  // Todas las preguntas de la especialidad activa (modo seed)
  const preguntasDeActiva = mapQuestions(CATALOGO[especialidadMedico] || []);

  // Todas las preguntas de todas las especialidades (para respetar mezcla en selected_keys)
  const preguntasDeTodas = ESPECIALIDADES.flatMap((esp) =>
    mapQuestions(CATALOGO[esp] || [])
  );

  // Si hay selección personalizada, muestra SOLO esas claves (de cualquier especialidad).
  // Si no hay selección, muestra todas las de la especialidad activa (comportamiento actual).
  const preguntas =
  selectedKeys // Set (aunque size=0) ⇒ usa exactamente esas claves
    ? preguntasDeTodas.filter((q) => selectedKeys.has(q.name))
    : preguntasDeActiva;

  // ⬇️ Gateo dependiente de switches (solo para pintar; no toca Config)
  const preguntasFiltradas = (Array.isArray(preguntas) ? preguntas : []).filter((q) => {
    if (q.name === "longitud" && !historia?.es_longitud) return false;
    if (q.name === "detalle_caidas_12_meses" && !historia?.caidas_ultimos_12_meses) return false;
    return true;
  });
    
  // =========================
  // PREGUNTAS NOM (SEPARADAS)
  // =========================
   
  const preguntasNOMGenerales = mapQuestions(PREGUNTAS_NOM24_GENERALES);

  const preguntasNOMGerontologia = mapQuestions(PREGUNTAS_NOM24_GERONTOLOGIA)
  .filter((q) =>
    variableAplica(q.name, { edad: edadPaciente })
  );

  const preguntasNOMSaludMaterna = mapQuestions(PREGUNTAS_NOM24_SALUD_MATERNA)
  .filter((q) =>
    variableAplica(q.name, {
      edad: edadPaciente,
      sexo,
      relacionTemporalEmbarazo: historia?.relacionTemporalEmbarazo,
      puerpera: historia?.puerpera,
      atencionPregestacionalRT: historia?.atencionPregestacionalRT,
    })
  );

  const preguntasNOMPediatria = mapQuestions(PREGUNTAS_NOM24_PEDIATRIA)
  .filter((q) =>
    variableAplica(q.name, {
      edad: edadPaciente,
      edadMeses: edadMesesPaciente,
      fecha_nacimiento: fechaNacimiento,
      ninoSanoRT: historia?.ninoSanoRT, 
      pruebaEDI: historia?.pruebaEDI,
      edasRT: historia?.edasRT,
     edasPlanTratamiento: historia?.edasPlanTratamiento,
     irasRT: historia?.irasRT
    })
  );

  // ------------------------------------------------------------
  // CONTROL DE MADRES GINECOLÓGICAS
  // ------------------------------------------------------------

  const madreSeleccionada =
    historia?.atencionPregestacionalRT ? "pregestacion" :
    historia?.relacionTemporalEmbarazo ? "embarazo" :
    historia?.puerpera ? "puerperio" :
    null;

  const preguntasMaternasFiltradas = preguntasNOMSaludMaterna.filter((q) => {
    if (!madreSeleccionada) return true;

    if (q.name === "atencionPregestacionalRT") return madreSeleccionada === "pregestacion";
    if (q.name === "relacionTemporalEmbarazo") return madreSeleccionada === "embarazo";
    if (q.name === "puerpera") return madreSeleccionada === "puerperio";

    return true;
  });

  //Aqui decidimos el switch de NOM 024
 const hayNOM = nom024 && (
    preguntasNOMGenerales.length > 0 ||
    preguntasNOMGerontologia.length > 0 ||
    preguntasMaternasFiltradas.length > 0 ||
    preguntasNOMPediatria.length > 0
  );

  if (preguntasFiltradas.length === 0 && !hayNOM) return null;
  

  const handleChange = (name, value) => {
    
    // LIMPIEZA PEDIATRÍA
  // ------------------------------------------------------------
  if (name === "ninoSanoRT") {
    setHistoria((prev) => ({
      ...prev,
      ninoSanoRT: value,
      pruebaEDI: "",
      resultadoEDI: "",
      edasRT: "",
      edasPlanTratamiento: "",
      recuperadoDeshidratacion: "",
      irasRT: "",
      irasPlanTratamiento: "",
      neumoniaRT: ""
    }));
    return;
  }
  // ------------------------------------------------------------
  // LIMPIEZA GINECOLOGÍA
  // ------------------------------------------------------------
  if (
    name === "atencionPregestacionalRT" ||
    name === "relacionTemporalEmbarazo" ||
    name === "puerpera"
  ) {
    setHistoria((prev) => ({
      ...prev,
      [name]: value,

      // hijas
      riesgo: "",
      trimestreGestacional: "",
      primeraVezAltoRiesgo: "",
      complicacionPorDiabetes: "",
      complicacionPorInfeccionUrinaria: "",
      complicacionPorPreeclampsiaEclampsia: "",
      complicacionPorHemorragia: "",
      hipertensionarterialprexistente: "",
      otrasAccPrescAcidoFolico: "",
      otrasACCApoyoTransladoAME: "",
      infeccionPuerperal: ""
    }));
    return;
  }
    setHistoria((prev) => ({ ...prev, [name]: value }));
  };

  const renderInput = (q) => {
    const value = historia[q.name] ?? "";

    if (q.type === "textarea") {
      return (
        <textarea
          id={q.name}
          value={value}
          placeholder={q.placeholder || ""}
          maxLength={q.maxLength ?? undefined}
          onChange={(e) => handleChange(q.name, e.target.value)}
        />
      );
    }

    if (q.type === "switch") {
      return (
        <label className="switch">
          <input
            type="checkbox"
            id={q.name}
            checked={!!value}
            onChange={(e) => handleChange(q.name, e.target.checked)}
          />
          <span className="switch__slider" />
        </label>
      );
    }

    if (q.type === "select") {
  let options =
    q.options && q.options.length ? q.options : ["eutocico", "cesarea"];

  // Filtrado de opciones según otra pregunta (opcionesPorDependencia)
  if (q.opcionesPorDependencia) {
    const { dependeDe, mapa } = q.opcionesPorDependencia;
    const valorPadre = historia?.[dependeDe];
    options = mapa[valorPadre] || [];
  }

      return (
        <select
          id={q.name}
          value={value}
          onChange={(e) => handleChange(q.name, e.target.value)}
        >
          <option value="">Seleccione…</option>
          {options.map((opt) => (
            <option key={opt} value={opt}>
               {q.labels?.[opt] || opt}
            </option>
          ))}
        </select>
      );
    }

    // text / number / date
    // DESPUÉS
    if (q.type === "multiselect") {
      const seleccionados = Array.isArray(value) ? value : (value ? String(value).split("&").map(Number) : []);
      return (
        <div>
          {q.options.map((opt) => (
            <label key={opt} style={{ display: "block", marginBottom: 4 }}>
              <input
                type="checkbox"
                checked={seleccionados.includes(opt)}
                onChange={(e) => {
                  let nuevos;
                  if (opt === 9) {
                    nuevos = e.target.checked ? [9] : [];
                  } else {
                    if (e.target.checked) {
                      nuevos = [...seleccionados.filter(v => v !== 9), opt];
                    } else {
                      nuevos = seleccionados.filter(v => v !== opt);
                    }
                  }
                  handleChange(q.name, nuevos.length ? nuevos.join("&") : "");
                }}
              />
              {" "}{q.labels?.[opt] || opt}
            </label>
          ))}
        </div>
      );
    }
    return (
      <input
        type={q.type}
        step={q.step}
        id={q.name}
        value={value}
        placeholder={q.placeholder || ""}
        maxLength={q.type === "text" ? q.maxLength ?? undefined : undefined}
        onChange={(e) => handleChange(q.name, e.target.value)}
      />
    );
  };

  return (
    <Accordion
      title="Cuestionario específico por especialidad"
      isOpen={openRubros["rubro-cuestionario-especialidad-historia"]}
      onToggle={() => toggleRubro("rubro-cuestionario-especialidad-historia")}
      anchorId="rubro-cuestionario-especialidad-historia"
    >
      <div className="rubro">
         {/* PREGUNTAS NOM */}
         
         {nom024 && preguntasNOMGenerales.length > 0 && (
            <>
              <div className="subrubro">
                <h3>Promoción de la salud</h3>
              </div>

              {preguntasNOMGenerales.map((q) => (
                <div key={`general-${q.name}`} className="subrubro">
                  <label htmlFor={q.name}>{q.label}</label>
                  {renderInput(q)}
                </div>
              ))}
            </>
          )}

         {nom024 && preguntasNOMGerontologia.length > 0 && (
          <>
            <div className="subrubro">
              <h3>Intervención Gerontológica</h3>
              <p>Escoge si se realizó para alguno</p>
            </div>
            {preguntasNOMGerontologia.map((q) => (
              <div key={`nom-${q.name}`} className="subrubro">
                <label htmlFor={q.name}>{q.label}</label>
                {renderInput(q)}
              </div>
            ))}
          </>
        )}

          {nom024 && preguntasMaternasFiltradas.length > 0 && (
           <>
             <div className="subrubro">
               <h3>Intervención en Salud Materna</h3>
               <p>Escoge si se realizó para alguno</p>
             </div>

            {preguntasMaternasFiltradas.map((q) => (
               <div key={`materna-${q.name}`} className="subrubro">
                 <label htmlFor={q.name}>{q.label}</label>
                 {renderInput(q)}
               </div>
             ))}
           </>
         )}

         {nom024 && preguntasNOMPediatria.length > 0 && (
          <>
            <div className="subrubro">
              <h3>Intervención Pediátrica</h3>
              <p>Escoge si se realizó para alguno</p>
            </div>
            {preguntasNOMPediatria.map((q) => (
              <div key={`pediatria-${q.name}`} className="subrubro">
                <label htmlFor={q.name}>{q.label}</label>
                {renderInput(q)}
              </div>
            ))}
          </>
        )}
         
         {preguntasFiltradas.map((q) => (
          <div key={q.name} className="subrubro">
            <label htmlFor={q.name}>{q.label}</label>
            {renderInput(q)}
          </div>
        ))}
      </div>
    </Accordion>
  );
}
